/*========================================================================
* $Id: emailalert.js 91712 2016-07-06 15:14:22Z daniel.eppensteiner $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "client/template",
  "utils/browser",
  "component!base",
  "i18n/i18n",
  "utils/mustache",
  "utils/jsonpath",
  "utils/persistedsourceinfo",
  "model/persisted_collection",
  "service/stub",
  "client/application",
  "backbone",
  "underscore",
  "jquery",
  "model/alertcenter",
  "api/v2/persisted",
  "service/channel",
  "service/channels",
  "api/v2/resources",
  "client/resourceinfo",
  "model/grouped_collection",
  "api/v2/search"
], function (
  Template,
  Browser,
  Base,
  i18n,
  Mustache,
  JSONPath,
  PersistedSourceInfo,
  PersistedCollection,
  Stub,
  Application,
  Backbone,
  _,
  $,
  AlertModels,
  Persisted,
  Channel,
  Channels,
  Resources,
  ResourceInfo,
  GroupedCollection,
  Search
) {

  Browser.loadCSS(ResourceInfo.scriptLocation + "../client/component/alertcenter/css/v2/alertcenter.css", "mbAlertsCSS");

  var ServiceInfo = function () {
    this.initialize.apply(this, arguments);
  }

  ServiceInfo.prototype = _.extend({}, Backbone.Events, {
  
    // userSourceInfo is the source for the information
    initialize: function (userSourceInfo) {
      this._persistedCollectionSchemaAvailablePromises = {};
      this.userSourceInfo = userSourceInfo;
      this.listenTo(userSourceInfo, "change reset", this.handleUserSourceInfoChange);
      this.resolvePromises();
    },

    // returns a promise that resolves with 
    //   * true, if there is a schema for the given path and channel.
    //   * false, if the channel does not provide such a schema
    //
    // The promise resolves only when there is userSourceInfo for the given channel,
    // waiting for changes.
    persistedCollectionSchemaAvailable: function (path, channel) {
      var key = path + "_" + channel.get("url");
      var promise = this._persistedCollectionSchemaAvailablePromises[key];
      if (promise) return promise;

      promise = new Channel.DeferredCallFinished();
      promise.path = path;
      promise.channel = channel;
      this._persistedCollectionSchemaAvailablePromises[key] = promise;

      this.resolvePromise(promise);

      return promise;
    },

    handleUserSourceInfoChange: function () {
      // currently we don't handle multiple changes of userSourceInfo
      this._userSourceInfoInitialized = true;
      this.resolvePromises();
    },

    resolvePromises: function () {
      var that = this;
      _.forEach(this._persistedCollectionSchemaAvailablePromises, function (promise) {
        that.resolvePromise(promise);
      });
    },

    resolvePromise: function (promise) {
       var sources = this.userSourceInfo.get("sources.sources");
       if (!sources) return;
        var source = sources[promise.channel.get("url")];
        if (!source) return; // OK?, what about federation and if channel[0] returns after channel[1]

        var persistedCollectionSchemaService = _.find(source.services, function (service) { return service.id === "persistedcollectionschema" });
        var matchingOptionWithPath = _.find(persistedCollectionSchemaService && persistedCollectionSchemaService.options, function (option) { return JSON.stringify(option.path) === JSON.stringify(promise.path) });
        var schemaAvailable = !!matchingOptionWithPath && !!matchingOptionWithPath.effective_available;

        promise.triggerDone(schemaAvailable);
     }
  });

  var originalGetModel = Application.prototype.getModel;
  Application.prototype.getModel = function (modelName) {
    var model = originalGetModel.apply(this, arguments);
    if (model) return model;

    if (/emailAlerts/.test(modelName)) {
      this.models.emailAlerts = new AlertModels.EmailAlertsModel({
        serviceInfo: this.serviceInfo,
        channel: this.models.channels.at(0)
      });
    }

  }

  var Alertcenter = Template.extend({

    initialize: function() {
      Template.prototype.initialize.apply(this, _.toArray(arguments));

      this.application.serviceInfo = new ServiceInfo(this.application.models.userSourceInfo);
      this.application.getModel("emailAlerts");

      this.listenTo(this.application.models.emailAlerts, "change:available", this.handleEmailAlertsAvailabilityChanged);
    },

    handleEmailAlertsAvailabilityChanged: function () {
      var emailAlertsAvailable = this.application.models.emailAlerts && this.application.models.emailAlerts.get("available");

      if (emailAlertsAvailable) {
        this.startURLParameterSearch();
        this.application.models.topMenu.add({
          id: "alertcenter",
          weight: 5,
          name: "alertcenter",
          icon: "bell",
          actionName: "showAlertCenter",
          className: "showAlertCenter mb-menu-item",
          title: "alerting_dashboard",
          translated_title: i18n("alerting_dashboard"),
        });

      } else {
        this.application.models.topMenu.remove("alertcenter");
        //todo...
      }
    },

    // is only called when emailalerts are available
    startURLParameterSearch: function () {
      var application = this.application;
      var that = this;
      var searchPathURLParameter = Browser.getURLParameter("emailalert"); // TODO: konfigurierbar (template, nur in oberster? application ausführen?)
      if (searchPathURLParameter) {
        application.models.emailAlerts.getAlertWithPath(
          searchPathURLParameter,
          function (emailAlert) {
            application.execute(function (application) {
              // don't start a search if there was already a search
              // should we use an initializationPromise as well?
              if (!application.getUnparsedUserQuery() && emailAlert) {
                var searchRequest = Search.SearchRequest.parse(emailAlert.get("data"));
                var retainViewSourceContextConstraints = that.application.options.retainViewSourceContextConstraints;
                that.application.options.retainViewSourceContextConstraints = true;

                // add emailalert tab at index 0
                application.models.tabs.add({
                  id: "emailalert",
                  name: "emailalert",
                  disabled: true
                }, { at: 0 });

                application.models.search.input.set(searchRequest);
                that.application.options.retainViewSourceContextConstraints = retainViewSourceContextConstraints;
              }
            });
          },
          function () {
            /* ignore? */
          }
        );
      }
    },

    createView: function(options) {
      var options = _.extend(this.schema.parseAttributes(this.attributeModel.getCamelCase()), options);
      return Template.prototype.createView.apply(this, [options]);
    },

    hasContent: function () {
      return false;
    },

    model: function(options) {
      return new GroupedCollection([], {
        delegate: this.application.models.emailAlerts.select({ owner: "TODO"}),
        groupingPath: ["frequency","groupTag"],
        compareFunctions: [ function (a,b) { return a-b } ]
      });
    },

    schema: new Template.Schema({
      attributes: {}
    })

  });

  Alertcenter.View = Base.extend({ });

  return Alertcenter;
});
